import useSWR from 'swr';

export interface Promotion {
  id: string;
  src_repo_id: string;
  dst_repo_id: string;
  src_slug: string;
  dst_slug: string;
  artifact_count: number;
  requested_by: string;
  requested_at: string;
  approved_by: string;
  approved_at?: string;
  status: 'pending' | 'approved' | 'rejected' | 'executed' | 'failed';
  note: string;
  error: string;
}

const fetcher = (url: string) =>
  fetch(url, { credentials: 'include' }).then((r) => r.json());

export function usePromotions() {
  return useSWR<Promotion[]>('/api/v1/promotions', fetcher);
}

export async function createPromotion(input: {
  src_repo_id: string;
  dst_repo_id: string;
  artifact_ids: string[];
  require_approval: boolean;
  note?: string;
}): Promise<{ id: string; status: string }> {
  const res = await fetch('/api/v1/promotions', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(input),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function approvePromotion(id: string): Promise<void> {
  await fetch(`/api/v1/promotions/${id}/approve`, { method: 'PUT', credentials: 'include' });
}
export async function rejectPromotion(id: string): Promise<void> {
  await fetch(`/api/v1/promotions/${id}/reject`, { method: 'PUT', credentials: 'include' });
}
export async function executePromotion(id: string): Promise<void> {
  const res = await fetch(`/api/v1/promotions/${id}/execute`, { method: 'PUT', credentials: 'include' });
  if (!res.ok && res.status !== 204) throw new Error(await res.text());
}
